import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useAnswersBySpaceQuery = ({ spaceId }) => {
  return useQuery({
    queryKey: QUERY_KEYS.answersBySpace(spaceId),
    queryFn: () => {
      return query({
        query: 'answersBySpace',
        variables: { space_id: spaceId }
      })
    },
    enabled: !!spaceId
  })
}
